export default "__VITE_ASSET__017d37be__"